"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationApp = exports.IntegrationStatus = exports.OrganisationSSOConnectionStatus = exports.OrganisationPermission = exports.OrganisationType = exports.OrganisationStatus = void 0;
var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus["ACTIVE"] = "ACTIVE";
    OrganisationStatus["INACTIVE"] = "INACTIVE";
})(OrganisationStatus = exports.OrganisationStatus || (exports.OrganisationStatus = {}));
var OrganisationType;
(function (OrganisationType) {
    OrganisationType["UNKNOWN"] = "UNKNOWN";
    OrganisationType["SUPPLIER"] = "SUPPLIER";
    OrganisationType["BUYER"] = "BUYER";
    OrganisationType["BOTH"] = "BOTH";
})(OrganisationType = exports.OrganisationType || (exports.OrganisationType = {}));
/**
 * @deprecated
 */
var OrganisationPermission;
(function (OrganisationPermission) {
    OrganisationPermission["PROJECT_VIEW"] = "PROJECT_VIEW";
    OrganisationPermission["PROJECT_DELETE"] = "PROJECT_DELETE";
    OrganisationPermission["PROJECT_CREATE"] = "PROJECT_CREATE";
    OrganisationPermission["PROJECT_MANAGE_PEOPLE"] = "PROJECT_MANAGE_PEOPLE";
})(OrganisationPermission = exports.OrganisationPermission || (exports.OrganisationPermission = {}));
var OrganisationSSOConnectionStatus;
(function (OrganisationSSOConnectionStatus) {
    OrganisationSSOConnectionStatus["ACTIVE"] = "ACTIVE";
    OrganisationSSOConnectionStatus["INACTIVE"] = "INACTIVE";
})(OrganisationSSOConnectionStatus = exports.OrganisationSSOConnectionStatus || (exports.OrganisationSSOConnectionStatus = {}));
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["DISABLED"] = "DISABLED";
    IntegrationStatus["ENABLED"] = "ENABLED";
    IntegrationStatus["FAILED"] = "FAILED";
})(IntegrationStatus = exports.IntegrationStatus || (exports.IntegrationStatus = {}));
var IntegrationApp;
(function (IntegrationApp) {
    IntegrationApp["SALESFORCE"] = "SALESFORCE";
    IntegrationApp["SAP"] = "SAP";
})(IntegrationApp = exports.IntegrationApp || (exports.IntegrationApp = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JnYW5pc2F0aW9uLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvb3JnYW5pc2F0aW9uL3R5cGVzL29yZ2FuaXNhdGlvbi5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksa0JBR1g7QUFIRCxXQUFZLGtCQUFrQjtJQUM1Qix1Q0FBaUIsQ0FBQTtJQUNqQiwyQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsa0JBQWtCLEdBQWxCLDBCQUFrQixLQUFsQiwwQkFBa0IsUUFHN0I7QUFFRCxJQUFZLGdCQUtYO0FBTEQsV0FBWSxnQkFBZ0I7SUFDMUIsdUNBQW1CLENBQUE7SUFDbkIseUNBQXFCLENBQUE7SUFDckIsbUNBQWUsQ0FBQTtJQUNmLGlDQUFhLENBQUE7QUFDZixDQUFDLEVBTFcsZ0JBQWdCLEdBQWhCLHdCQUFnQixLQUFoQix3QkFBZ0IsUUFLM0I7QUFFRDs7R0FFRztBQUNILElBQVksc0JBS1g7QUFMRCxXQUFZLHNCQUFzQjtJQUNoQyx1REFBNkIsQ0FBQTtJQUM3QiwyREFBaUMsQ0FBQTtJQUNqQywyREFBaUMsQ0FBQTtJQUNqQyx5RUFBK0MsQ0FBQTtBQUNqRCxDQUFDLEVBTFcsc0JBQXNCLEdBQXRCLDhCQUFzQixLQUF0Qiw4QkFBc0IsUUFLakM7QUFFRCxJQUFZLCtCQUdYO0FBSEQsV0FBWSwrQkFBK0I7SUFDekMsb0RBQWlCLENBQUE7SUFDakIsd0RBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUhXLCtCQUErQixHQUEvQix1Q0FBK0IsS0FBL0IsdUNBQStCLFFBRzFDO0FBRUQsSUFBWSxpQkFJWDtBQUpELFdBQVksaUJBQWlCO0lBQzNCLDBDQUFxQixDQUFBO0lBQ3JCLHdDQUFtQixDQUFBO0lBQ25CLHNDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFKVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQUk1QjtBQUVELElBQVksY0FHWDtBQUhELFdBQVksY0FBYztJQUN4QiwyQ0FBeUIsQ0FBQTtJQUN6Qiw2QkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQUhXLGNBQWMsR0FBZCxzQkFBYyxLQUFkLHNCQUFjLFFBR3pCIn0=